import * as React from "react";
import type { SVGProps } from "react";
const SvgWeddingRings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.998 6.664 4.6 4.8a1 1 0 0 1 .09-1.31l1.2-1.2A1 1 0 0 1 6.6 2h4.8a1 1 0 0 1 .71.29l1.2 1.2a1 1 0 0 1 .09 1.31l-1.406 1.875a7 7 0 0 1 2.76 2.37C15 9.014 15.248 9 15.5 9a6.51 6.51 0 0 1 6.5 6.5 6.51 6.51 0 0 1-6.5 6.5 6.51 6.51 0 0 1-4.869-2.2c-.53.13-1.077.198-1.631.2a7 7 0 0 1-7-7 7 7 0 0 1 3.998-6.336Zm2.555 3.23A1 1 0 0 0 9.8 9.6l.962-1.282a5 5 0 0 1 1.94 1.319A6.508 6.508 0 0 0 9 15.5c.001.858.172 1.698.493 2.476A5 5 0 0 1 4 13a5 5 0 0 1 3.233-4.69L8.2 9.6a1 1 0 0 0 .353.294ZM9 7.29l-2.28-3L7 4h4l.28.29-2.28 3ZM15.5 20a4.51 4.51 0 0 1-2.866-1.036 7.005 7.005 0 0 0 3.049-7.96A4.51 4.51 0 0 1 20 15.5a4.51 4.51 0 0 1-4.5 4.5ZM14 13c0-.56-.093-1.11-.273-1.633A4.509 4.509 0 0 0 11 15.5a4.51 4.51 0 0 0 .414 1.878A4.996 4.996 0 0 0 14 13Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWeddingRings;
